import { create } from "zustand";

export interface AuthGateOpenOptions {
  /** Özel başlık (çevrilmiş metin). Verilmezse varsayılan i18n metni kullanılır. */
  title?: string;
  /** Özel açıklama (çevrilmiş metin). Verilmezse varsayılan i18n metni kullanılır. */
  description?: string;
  /**
   * Login/register sonrası gidilecek adres. Verilmezse mevcut sayfa
   * (`AuthGateDialog` persist eder). Mağaza gibi private bir hedefe
   * tıklanınca buraya o hedef yazılır — aksi halde landing'e dönerdik.
   */
  redirectTo?: string;
}

interface AuthGateStore {
  isOpen: boolean;
  title: string | null;
  description: string | null;

  openAuthGate: (options?: AuthGateOpenOptions) => void;
  closeAuthGate: () => void;
}

/**
 * Auth Gate Store
 * Public modda auth gerektiren bir aksiyon denendiğinde gösterilen
 * login/register popup'ının global state'i. App genelinde kullanılabilir.
 */
export const useAuthGateStore = create<AuthGateStore>((set) => ({
  isOpen: false,
  title: null,
  description: null,

  openAuthGate: (options) =>
    set({
      isOpen: true,
      title: options?.title ?? null,
      description: options?.description ?? null,
    }),

  closeAuthGate: () => set({ isOpen: false }),
}));
